import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {Menu, Segment} from 'semantic-ui-react';
import TopLevel from './TopLevel';
import _ from 'lodash';
import {API_ATTACHMENT_GET_SUCCESS} from 'common/types';
import {SideNavInternal} from 'go/components/dynamic/layout/SideNavInternal';
import {isFemaUser, isRecipientUser} from 'common/utils';
import {isSubApplicationConfig} from 'go/components/dynamic/modules/grantLandingPage/utils';

export class AttachmentNavItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checking: true,
      shouldLoad: false,
    };
  }

  componentDidMount() {
    let {
      token,
      subGrantId,
      grantId,
      hasFemaPermissions,
      hasRecipientPermissions,
      config,
    } = this.props;
    const {configType} = config;
    this.configName = isSubApplicationConfig(configType)
      ? hasFemaPermissions
        ? 'subAttachments'
        : 'subAttachments_external'
      : hasFemaPermissions
      ? 'attachments'
      : 'attachments_external';
    if (
      isSubApplicationConfig(configType) &&
      !hasFemaPermissions &&
      !hasRecipientPermissions
    ) {
      this.setState({
        checking: false,
      });
    } else {
      let entityType;
      let entityId;
      if (isSubApplicationConfig(configType)) {
        entityType = 'subGrant';
        entityId = subGrantId;
      } else {
        entityType = 'grant';
        entityId = grantId;
      }
      this.props
        .getAttachments(token, entityId, entityType)
        .then((res) => {
          if (
            res.type === API_ATTACHMENT_GET_SUCCESS &&
            (hasFemaPermissions || !_.isEmpty(res.payload))
          ) {
            // we have the config for the Attachments from this res along the data... but can't be sure
            // that other nav items will get their own configs, so rely on the landing page to provide
            this.setState({
              shouldLoad: true,
            });
          }
          this.setState({
            checking: false,
          });
        })
        .catch((err) => {
          console.log(
            `Attachment could not be retrieved for entityId: ${entityId} and entityType: ${entityType}.`
          );
          this.setState({
            checking: false,
          });
        });
    }
  }

  setActivePage(configName) {
    this.props.loadPageWithConfig(configName);
  }

  render() {
    const {baseClass, isActive, config} = this.props;
    const {configType} = config;
    const name = 'Attachments';
    if (this.state.checking) {
      return (
        <Segment tertiary inverted>
          Checking for Attachments...
        </Segment>
      );
    } else if (this.state.shouldLoad) {
      return (
        <React.Fragment>
          <TopLevel
            name={name}
            baseClass={baseClass}
            handleClick={() => this.setActivePage(this.configName)}
            active={isActive}
            isExpandable={false}
          />
          {isActive &&
            config &&
            _.toLower(config.configType) === _.toLower(this.configName) && (
              <React.Fragment>
                <SideNavInternal
                  navToSpecificLocation={() => {
                    /* this is the key to making the sidenav active state work
                          don't use until figuring out how to incorporate VisibilitySensor into this
                        */
                  }}
                  location={this.props.location}
                  title={`${name} Navigation`}
                  startingIndentLevel={1}
                  {...config.payload}
                />
              </React.Fragment>
            )}
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  getAttachments: (token, id, type) => {
    const action = ApiActions.attachments.retrieveAttachmentsForEntity(token, id, type);
    const res = dispatch(action);
    return res;
  },
});

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    hasFemaPermissions: isFemaUser(state.auth.permissions),
    hasRecipientPermissions: isRecipientUser(state.auth.permissions),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentNavItem);
